import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import AddCircle from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';

const WidgetPlaceHolder = ({
  baseWidgetPlaceHolder,
  setWhichPopup,
  setPanelIndex,
  slot,
  panelIndex
}) => {
  const handleClick = () => {
    setPanelIndex(slot);
    setWhichPopup('widget_preview');
  };

  return (
    <Box
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      border={baseWidgetPlaceHolder ? '3px dashed #346C9F' : '1px dashed #000'}
      p={baseWidgetPlaceHolder ? 1 : 0}
      minHeight="300px"
      height="100%"
      borderRadius={4}
      overflow="hidden"
    >
      {baseWidgetPlaceHolder && panelIndex === slot ? (
        <img
          src={baseWidgetPlaceHolder}
          alt=""
          style={{
            width: '100%',
            display: 'flex',
            height: '100%'
          }}
        />
      ) : (
        <IconButton onClick={handleClick}>
          <AddCircle color="primary" style={{ fontSize: '60px' }} />
        </IconButton>
      )}
    </Box>
  );
};

WidgetPlaceHolder.propTypes = {
  baseWidgetPlaceHolder: PropTypes.string.isRequired,
  setWhichPopup: PropTypes.func.isRequired,
  setPanelIndex: PropTypes.func.isRequired,
  slot: PropTypes.number.isRequired,
  panelIndex: PropTypes.number
};

WidgetPlaceHolder.defaultProps = {
  panelIndex: null
};

export default WidgetPlaceHolder;
